var _react = $parcel$interopDefault(require("react"));

var _classnames = $parcel$interopDefault(require("classnames"));

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/Downloads/react-spectrum-v3/packages/@react-aria/visually-hidden/src/VisuallyHidden.css
var $e2ec7683a5efeba3448b0a5b7c6804d$exports = {};
$e2ec7683a5efeba3448b0a5b7c6804d$exports = {
  "u-react-spectrum-screenReaderOnly": "_u-react-spectrum-screenReaderOnly_f0a76",
  "is-focusable": "_is-focusable_f0a76"
};
var $e2ec7683a5efeba3448b0a5b7c6804d$$interop$default = $parcel$interopDefault($e2ec7683a5efeba3448b0a5b7c6804d$exports);

/**
 * VisuallyHidden hides its children visually, while keeping content visible
 * to screen readers.
 */
function VisuallyHidden(props) {
  let {
    children,
    className,
    elementType: Element = 'div',
    isFocusable
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["children", "className", "elementType", "isFocusable"]);

  className = _classnames($e2ec7683a5efeba3448b0a5b7c6804d$$interop$default['u-react-spectrum-screenReaderOnly'], {
    [$e2ec7683a5efeba3448b0a5b7c6804d$$interop$default['is-focusable']]: isFocusable
  }, className);
  return /*#__PURE__*/_react.createElement(Element, _babelRuntimeHelpersExtends({
    className: className
  }, otherProps), children);
}

exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=main.js.map
